export interface FuelSupplierAttachmentGetRecord {
  id: number;
  originalFileName: string;
  uploadTimestamp: string;
  userName: string;
}
